import { createFileRoute } from '@tanstack/react-router';

import { LegalPage } from '@/features/legalPages/LegalPage';

export const Route = createFileRoute('/_static/legal-notice')({
	component: LegalNoticePage,
});

function LegalNoticePage() {
	return <LegalPage page="legalNotice" isPlaceholder />;
}
